export const NAVBAR_WIDTH = 260;